import "./index.scss";
import LogoH from "../../assets/images/logo-h.png";
import codechefLogo from "../../assets/images/codechef.png";
import LogoSubtitle from "../../assets/images/Sudip_logo_white.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import {
	faHome,
	faUser,
	faEnvelope,
	faScrewdriverWrench,
	faLeetcode,
} from "@fortawesome/free-solid-svg-icons";
import { SiLeetcode } from "react-icons/si";
import { Link, NavLink } from "react-router-dom";

const Sidebar = () => {
	return (
		<>
			<div className="nav-bar">
				<Link
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}
					className="logo"
					to="/"
				>
					<img src={LogoH} alt="Logo" />
					<span style={{ fontSize: "15px", color: "#e4e4e7" }}>
						Haider
					</span>
				</Link>
				<nav>
					<NavLink exact="true" activeclassname="active" to="/">
						<FontAwesomeIcon icon={faHome} color="#4d4d4e" />
					</NavLink>
					<NavLink
						activeclassname="active"
						className="about-link"
						to="/about"
					>
						<FontAwesomeIcon icon={faUser} color="#4d4d4e" />
					</NavLink>

					<NavLink
						activeclassname="active"
						className="skills-link"
						to="/skills"
					>
						<FontAwesomeIcon icon={faScrewdriverWrench} color="#4d4d4e" />
					</NavLink>

					<NavLink
						activeclassname="active"
						className="contact-link"
						to="/contact"
					>
						<FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
					</NavLink>
				</nav>
				<ul>
					<li>
						<a
							href="https://www.linkedin.com/in/mohd-haider-96a82620b/"
							target="_blank"
							rel="noreferrer"
						>
							<FontAwesomeIcon icon={faLinkedin} color="#b9b9b9" />
						</a>
					</li>
					<li>
						<a
							href="https://github.com/mohdhaider07"
							target="_blank"
							rel="noreferrer"
						>
							<FontAwesomeIcon icon={faGithub} color="#b9b9b9" />
						</a>
					</li>
					<li>
						<a
							href="https://leetcode.com/mohdhaider07/"
							target="_blank"
							rel="noreferrer"
						>
							<SiLeetcode style={{ color: "#b9b9b9" }} />
							{/* <FontAwesomeIcon icon={faLeetcode} color="#b9b9b9" /> */}
						</a>
					</li>
				</ul>
			</div>
		</>
	);
};

export default Sidebar;
